<template>
  <section>
    <div class="search-content">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-button class="search-btn" size="small" type="main" icon="el-icon-edit-outline" @click="handleBatchShow">批量设置</el-button>
          <el-button class="search-btn" size="small" type="search" icon="el-icon-search" @click="handleSearchDialog">筛选</el-button>
        </el-col>
        <el-col :span="10" style="text-align: right;">
          <el-input class="search-input" size="small" placeholder="请输入企业名称" v-model="searchInfo.enterpriseName"></el-input>
          <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-content">
      <el-table
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%;margin-top:20px">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          prop="enterpriseName"
          label="企业名称"
          width="120">
        </el-table-column>
        <el-table-column
          prop="enterpriseCode"
          width="180"
          label="企业代码">
        </el-table-column>
        <el-table-column
          prop="parkName"
          label="地区/园区"
          width="150">
        </el-table-column>
        <el-table-column
          prop="infoType"
          label="诉求类型"
          :formatter="infoTypeFormatter"
          width="100">
        </el-table-column>
        <el-table-column
          prop="appealContent"
          label="诉求事项"
          :formatter="contentFormatter"
          width="180">
        </el-table-column>
        <el-table-column
          prop="showOrgName"
          label="显示企业名称"
          :formatter="showOrgNameFormatter"
          width="110">
        </el-table-column>
        <el-table-column
          prop="showContent"
          label="显示诉求事项"
          :formatter="showContentFormatter"
          width="110">
        </el-table-column>
        <el-table-column label="操作" width="360">
          <template slot-scope="scope">
            <el-button type="main" size="mini" icon="el-icon-setting" @click="handleDetail(scope.$index, scope.row)">设置</el-button>
            <el-button v-if="user.role==='admin'" type="danger" size="mini" icon="el-icon-delete-solid" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog title="筛选" width="75%" :visible.sync="searchDialogVisible" :close-on-click-modal="false">
      <el-form :model="searchInfo" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="企业名称：">
              <el-input v-model="searchInfo.enterpriseName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="信用代码：">
              <el-input v-model="searchInfo.enterpriseCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="法定代表人：">
              <el-input v-model="searchInfo.legalPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业联系人：">
              <el-input v-model="searchInfo.contactPerson"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系电话：">
              <el-input v-model="searchInfo.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证：">
              <el-input v-model="searchInfo.contactIdCard"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="地区/园区：">
              <el-select
                style="width: 100%"
                v-model="searchInfo.park"
                filterable
                placeholder="请输入地区/园区" clearable>
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="诉求类型：">
              <el-select v-model="searchInfo.appealType" placeholder="请选择" style="width:100%" clearable>
                <el-option
                  v-for="item in appealTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="searchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSearch">搜 索</el-button>
      </div>
    </el-dialog>
    <el-dialog title="设置" width="400px" :visible.sync="handleDetailInfoVisible" :close-on-click-modal="false">
      <el-form :model="appealSettingInfo" label-width="150px">
        <el-form-item label="显示企业名称" prop="showOrgName">
          <el-select v-model="appealSettingInfo.showOrgName" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in showTypeStatus"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示诉求事项" prop="showContent">
          <el-select v-model="appealSettingInfo.showContent" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in showTypeStatus"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDetailInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSettingSaveInfo">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="批量设置" width="400px" :visible.sync="handleBatchShowVisible" :close-on-click-modal="false">
      <el-form :model="appealSettingInfo" label-width="150px">
        <el-form-item label="显示企业名称" prop="showOrgName">
          <el-select v-model="appealSettingInfo.showOrgName" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in showTypeStatus"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="显示诉求事项" prop="showContent">
          <el-select v-model="appealSettingInfo.showContent" placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in showTypeStatus"
              :key="item.type"
              :label="item.name"
              :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleBatchShowVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBatchSettingSaveInfo">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import Common from '@/components/common/Common'
  import { Table } from '@/components/common/Table'
  import { enterpriseAppealList, enterpriseAppealSet,enterpriseAppealDelete, portalDictionary,portalParkList, listOrg, enterpriseAppealBatchShowSet } from '@/api/restapi.js'
  export default {
    mixins: [Table],
    data() {
      return {
        user: Common.user,
        organizationList: [],
        parkList: [],
        appealTypeList: [],
        showTypeStatus: [{
          type: 0,
          name: '全隐藏'
        },{
          type: 2,
          name: '部分隐藏'
        },{
          type: 1,
          name: '不隐藏'
        }],
        appealSettingInfo: {
          showOrgName: 0,
          showContent: 0
        },
        handleDeliveryInfoVisible: false,
        handleInfoVisible: false,
        handleDetailInfoVisible: false,
        handleWithdrawVisible: false,
        handleBatchShowVisible: false
      }
    },
    mounted () {
      portalDictionary('appeal_type').then(res => {
        if (res.data.code === 0) {
          this.appealTypeList = res.data.data
        }
      })
      listOrg(1, 99999).then(res => {
        if(res.data.code === 0){
          this.organizationList = res.data.data.list
        }
      })
      this.queryParkAsync('')
    },
    methods: {
      handleBatchShow () {
        this.appealSettingInfo = Object.assign({
          showOrgName: 0,
          showContent: 0
        })
        this.handleBatchShowVisible = true
      },
      handleBatchSettingSaveInfo () {
        enterpriseAppealBatchShowSet(this.selectIds,
          this.appealSettingInfo.showOrgName,this.appealSettingInfo.showContent).then(res => {
          if (res.data.code === 0) {
            this.handleBatchShowVisible = false
            this.$message({
              type: 'success',
              message: '设置成功'
            })
            this.searchList()
          }else {
            this.$message({
              type: 'error',
              message: '设置失败'
            })
          }
        })
      },
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            // cb(names)
            this.parkList = names
          }
        })
      },
      getOrgName (orgId) {
        let name = ''
        this.organizationList.some(org => {
          if (org.id === orgId) {
            name = org.name
            return true
          }
        })
        return name
      },
      handleDelete (col, row) {
        this.$confirm('确认要删除该记录', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          enterpriseAppealDelete(row.id).then(res => {
            if (res.data.code === 0) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.searchList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败'
              })
            }
          })
        })
      },
      handleDetail (col, row) {
        this.appealSettingInfo = Object.assign({
          id: row.id,
          showOrgName: row.showOrgName?row.showOrgName:0,
          showContent: row.showContent?row.showContent:0
        })
        this.handleDetailInfoVisible = true
      },
      handleSettingSaveInfo () {
        enterpriseAppealSet({
          id: this.appealSettingInfo.id,
          showOrgName: this.appealSettingInfo.showOrgName,
          showContent: this.appealSettingInfo.showContent
        }).then(res => {
          if (res.data.code === 0) {
            this.handleDetailInfoVisible = false
            this.$message({
              type: 'success',
              message: '设置成功'
            })
            this.searchList()
          } else {
            this.$message({
              type: 'error',
              message: '设置失败'
            })
          }
        })
      },
      searchMethod () {
        return enterpriseAppealList(this.pageInfo.page,this.pageInfo.size, this.searchInfo)
      },
      addMethod () {
      },
      beforeUpdate () {
      },
      updateMethod () {
      },
      valForm (formRef) {
        let isValid = true
        this.$refs[formRef].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          this.$message({
            showClose: true,
            message: '请检查填写内容',
            type: 'error'
          })
        }
        return isValid
      },
      contentFormatter (row, col) {
        return row.appealContent.substring(0,10) + (row.appealContent.length<10?'':'...')
      },
      showOrgNameFormatter (row, col) {
        if (row.showOrgName){
          if (row.showOrgName===1){
            return '不隐藏'
          }
          if (row.showOrgName===2){
            return '部分隐藏'
          }
        }
        return '全部隐藏'
      },
      showContentFormatter (row, col) {
        if (row.showContent===1){
          return '不隐藏'
        }
        if (row.showContent===2){
          return '部分隐藏'
        }
        return '全部隐藏'
      },
      infoTypeFormatter (row, col) {
        if (row.infoType === 'pay') {
          return '保障支付'
        }
        return '诉求意见'
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
</style>



// WEBPACK FOOTER //
// src/components/AppealManage.vue